import {
  ClockIcon,
  CurrencyDollarIcon,
  LightBulbIcon,
  LockClosedIcon,
  PencilAltIcon,
  PuzzleIcon,
} from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

const pains = [
  {
    name: 'I need new content',
    description: "I'm tired of making new, high-quality content all the time.",
    icon: PencilAltIcon,
  },
  {
    name: 'I need more examples',
    description:
      "I'm not sure how to use AI for my business to make this easier.",
    icon: LightBulbIcon,
  },
  {
    name: "I don't want to increase expenses",
    description: "I'm happy to try AI, but I'm worried about its cost.",
    icon: CurrencyDollarIcon,
  },
  {
    name: "I don't have much time to learn",
    description: "I know it could be useful, but I don't have experience yet.",
    icon: ClockIcon,
  },
  {
    name: "I'm not tech savvy",
    description: "It all feels too technical, I'm not a technical person.",
    icon: PuzzleIcon,
  },
  {
    name: 'What about privacy?',
    description: 'I have concerns about privacy and how my data is used.',
    icon: LockClosedIcon,
  },
];

export default function UserPainWorkshop() {
  const { t } = useLocale('ai-workshops');

  return (
    <section className='border-b border-slate-100 bg-white py-24 dark:border-slate-900 dark:bg-slate-950 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='grid grid-cols-1 gap-x-16 gap-y-12 lg:grid-cols-3'>
          <div className='max-w-xl'>
            <h2 className='text-base font-semibold leading-7 text-indigo-600 dark:text-indigo-500'>
              {t('We hear you')}
            </h2>
            <p className='mt-2 text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-4xl'>
              {t('Does this sound familiar?')}
            </p>
            <p className='mt-4 text-lg leading-8 text-slate-600 dark:text-slate-400'>
              {t(
                'These are the worries we hear before every workshop. The session is built to clear every one of them.',
              )}
            </p>
          </div>

          <dl className='grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:col-span-2'>
            {pains.map((pain) => (
              <div key={pain.name}>
                <dt className='flex items-center gap-x-4'>
                  <div className='flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-800'>
                    <pain.icon
                      className='h-6 w-6 text-indigo-600 dark:text-indigo-500'
                      aria-hidden='true'
                    />
                  </div>
                  <p className='text-base font-bold leading-6 text-slate-900 dark:text-slate-100'>
                    &ldquo;{t(pain.name)}&rdquo;
                  </p>
                </dt>
                <dd className='mt-3 pl-14 text-sm leading-relaxed text-slate-600 dark:text-slate-400'>
                  {t(pain.description)}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
